import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopyright, faEnvelope, faHeart } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import React from 'react'

import logo from '../images/logo-white.png'

const Footer = () => (
  <footer>
    <div className="container py-5">
      <div className="row">
        <div className="col-md-6 pb-3">
          <div className="logo-container">
            <div className="logo-contents">
              <a href="/"><img src={ logo } id="logo" alt="Simple Summers Logo" style={{ maxHeight: '4rem' }} /></a>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div><a href="/about-us/">About Us</a></div>
          <div><a href="/search/">All Camps</a></div>
        </div>
        <div className="col-md-2">
          <div><a href="/privacy/">Privacy Policy</a></div>
          <div><a href="/terms/">Terms of Service</a></div>
        </div>
        <div className="col-md-2 pb-3">
          <div><a href="/contact-us/">Contact Us</a></div>
          <div>
            <a href="mailto:hello@simplesummers.com"><FontAwesomeIcon icon={faEnvelope} /></a>
            <a href="https://www.instagram.com/simplesummersIG/" className="pl-2" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="https://www.facebook.com/simplesummers/" className="pl-2"><FontAwesomeIcon icon={faFacebook} target="_blank" rel="noopener noreferrer" /></a>
          </div>
        </div>
      </div>
      <div className="row align-items-end">
        <div className="col-md-12 legal text-center pt-3">
          Copyright <FontAwesomeIcon icon={faCopyright} /> 2018-{ new Date().getFullYear() } Simple Summers, LLC.  All rights reserved.  <br className="d-none d-lg-block"/>
          Made with <FontAwesomeIcon icon={faHeart} /> in Sacramento, California.
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
